import React, { useEffect, useMemo, useRef, useState } from 'react';
import service from '../../config/services';
import defaultFoodImage from '../../assets/images/def_img_food.png';
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp';
import './index.less';
const { domain: { chatbot } } = service;

const getProductId = (item = {}) => item.productId || item.productid || item.id || item.goodsId || item.skuId;
const getProductName = (item = {}) => item.productName || item.name || item.title || '菜品';
const getProductPrice = (item = {}) => item.price || item.amount || item.salePrice || '';
const getProductImage = (item = {}) => {
  if (item.image) return item.image;
  if (Array.isArray(item.images) && item.images.length > 0) return item.images[0];
  return '';
};

const parseMessagePayload = data => {
  if (!data) return null;
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  }
  if (typeof data === 'object') return data;
  return null;
};

const getProductsFromPayload = payload => {
  if (!payload || typeof payload !== 'object') return null;
  if (Array.isArray(payload.products)) return payload.products;
  if (Array.isArray(payload.data)) return payload.data;
  if (payload.payload && Array.isArray(payload.payload.products)) return payload.payload.products;
  if (payload.result && Array.isArray(payload.result.products)) return payload.result.products;
  return null;
};

const normalizeProducts = products => products
  .map(item => ({
    productId: getProductId(item),
    name: getProductName(item),
    price: getProductPrice(item),
    image: getProductImage(item)
  }))
  .filter(item => item.productId)
  .slice(0, 8);

const MaxKBChatBot = ({ chatbotId = 'cm6ufvzyo000y10x1fp81asqh' }) => {
  const containerRef = useRef(null);
  const [cards, setCards] = useState([]);
  const [panelVisible, setPanelVisible] = useState(true);
  const chatbotHost = useMemo(() => {
    try {
      return new URL(chatbot).host;
    } catch (error) {
      return chatbot.replace(/^https?:\/\//, '');
    }
  }, []);

  const jumpToProductDetail = productId => {
    if (!productId) return;
    addBehaviorsRecord({
      behaviorType: 160200,
      behavior: 160206,
      value1: `${productId}`,
      value2: 'ai_recommend_card'
    });
    const hashQuery = window.location.hash.split('?')[1] || '';
    const hashParams = new URLSearchParams(hashQuery);
    const searchParams = new URLSearchParams(window.location.search);
    const areaid = searchParams.get('areaid') || hashParams.get('areaid') || hashParams.get('areaId') || '';
    const search = new URLSearchParams({ productId: `${productId}` });
    if (areaid) search.set('areaid', areaid);
    window.location.href = `${window.location.origin}${window.location.pathname}#/relate-product?${search.toString()}`;
  };

  useEffect(() => {
    let script;
    let zapierBot;
    const widgetSelector = 'zapier-interfaces-chatbot-embed[data-owner="maxkb-chatbot"]';
    const protocol = window.location.protocol.replace(':', '');
    const src = `${chatbot}/chat/api/embed?protocol=${protocol}&host=${chatbotHost}&token=${chatbotId}`;

    if (!document.querySelector(`script[src="${src}"]`)) {
      script = document.createElement('script');
      script.defer = true;
      script.async = true;
      script.src = src;
      script.setAttribute('data-owner', 'maxkb-chatbot');
      document.body.appendChild(script);
    }

    if (containerRef.current && !containerRef.current.querySelector(widgetSelector)) {
      zapierBot = document.createElement('zapier-interfaces-chatbot-embed');
      zapierBot.setAttribute('is-popup', 'true');
      zapierBot.setAttribute('chatbot-id', chatbotId);
      zapierBot.setAttribute('data-owner', 'maxkb-chatbot');
      containerRef.current.appendChild(zapierBot);
    }

    const syncCards = payload => {
      const products = getProductsFromPayload(payload);
      const isCardPayload = payload.type === 'maxkb_product_cards' || payload.event === 'maxkb_product_cards';
      if (!products || (!isCardPayload && !payload.products)) return;
      const normalized = normalizeProducts(products);
      if (normalized.length > 0) {
        setCards(normalized);
        setPanelVisible(true);
      }
    };

    const handleMessage = event => {
      const payload = parseMessagePayload(event.data);
      if (!payload) return;
      syncCards(payload);
    };

    const handleCustomEvent = event => {
      const payload = event.detail;
      if (!payload) return;
      syncCards(payload);
    };

    window.addEventListener('message', handleMessage);
    window.addEventListener('maxkb_product_cards', handleCustomEvent);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('maxkb_product_cards', handleCustomEvent);
    };
  }, [chatbotHost, chatbotId]);

  return (
    <>
      <div ref={containerRef}></div>
      {cards.length > 0 && panelVisible ? (
        <div className='maxkb-card-panel'>
          <div className='maxkb-card-panel__header'>
            <div className='maxkb-card-panel__title'>AI 推荐菜品</div>
            <button
              type='button'
              onClick={() => setCards([])}
              className='maxkb-card-panel__clear'
            >
              清空
            </button>
            <button
              type='button'
              onClick={() => setPanelVisible(false)}
              className='maxkb-card-panel__close'
            >
              关闭
            </button>
          </div>
          {cards.map(item => (
            <div
              key={item.productId}
              onClick={() => jumpToProductDetail(item.productId)}
              className='maxkb-card-item'
            >
              <img
                src={item.image || defaultFoodImage}
                alt={item.name}
                className='maxkb-card-item__image'
              />
              <div className='maxkb-card-item__content'>
                <div className='maxkb-card-item__name'>{item.name}</div>
                <div className='maxkb-card-item__price'>{item.price ? `¥${item.price}` : ''}</div>
                <div className='maxkb-card-item__action'>查看详情 {'>'}</div>
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default MaxKBChatBot;